<div *ngIf="isLoading|async" class="overlay">
  <mat-progress-spinner mode="indeterminate" class="spinner" [color]="color" [value]="value">
  </mat-progress-spinner>
</div>